import type { SchemaModel } from "@aws-amplify/core/internals/utils";
import type { StringFieldType } from "./StringFieldType";
import type { Field } from "@aws-amplify/data-schema/dist/esm/runtime/bridge-types";

export function toTitleField(model: SchemaModel): Field | undefined {
  return Object.values(model.fields).find(
    (f) =>
      ["String", "AWSEmail"].includes(f.type as StringFieldType) &&
      f.isRequired,
  );
}
